import s from './teacher-about.module.scss'

export const TeacherAbout = ({teacher}) => {
    if(teacher?.teacher_bio == null) return null

    return(
        <div className={s.wrapper}>
            <h1 className={s.header}>О себе</h1>
            <div className={s.container}>
                <p className={s.info}>
                    {teacher?.teacher_bio}
                </p>
            </div>
        </div>
    )
}